import { Toaster } from 'react-hot-toast';
import { Route, Routes, useLocation } from 'react-router-dom';
import Navbar from './Components/Navbar/Navbar';
import About from './Pages/About';
import Blogs from './Pages/Blogs';
import Home from './Pages/Home';
import ProjectDetail from './Pages/ProjectDetail';
import LoadingBar from 'react-top-loading-bar'
import { useEffect, useState } from 'react';
import { motion } from "framer-motion"

function App() {
  const [progress, setProgress] = useState(0)
  const location = useLocation();

  useEffect(() => {
    setProgress(100);
  }, [location]);

  return (
    <div>
      <Toaster />
      <LoadingBar
        color='#2BA6D7'
        // transitionTime={1000}
        progress={progress}
        onLoaderFinished={() => setProgress(0)}
      />
      <Routes>
        <Route path='/' element={<Home></Home>}></Route>
        <Route path='/about-me' element={<About />}></Route>
        <Route path='/blogs' element={<Blogs />}></Route>
        <Route path='/project/:id' element={<ProjectDetail />}></Route>
      </Routes>
    </div>
  );
}

export default App;
